import { render, staticRenderFns } from "./LoginSso.vue?vue&type=template&id=813d12d6&"
import script from "./LoginSso.vue?vue&type=script&lang=js&"
export * from "./LoginSso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports